class DatePeriodModel {
    public Start: Date = null;
    public End: Date = null;

    constructor(init?: Partial<DatePeriodModel>) {
        Object.assign(this, init);
    }
}

export { DatePeriodModel };
